export const helpSection = '/help';

export const helpPath = helpSection;
export const helpContactSupportPath = `${helpSection}/contact-support`;
